import { Link } from "react-router-dom";
import { useI18n } from "../contexts/LanguageContext";
import { API_BASE } from "../lib/api";
import { MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="container-pad mx-auto max-w-[1400px] grid grid-cols-1 md:grid-cols-4 gap-10 py-16">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src="/logo.jpg" alt="ENCES Global" className="w-11 h-11 rounded-xl object-cover ring-2 ring-white/20" />
            <div className="leading-tight">
              <div className="font-extrabold tracking-tight text-lg">ENCES Global</div>
              <div className="text-[10px] tracking-[0.25em] text-white/60 uppercase">Since 2009</div>
            </div>
          </div>
          <p className="text-white/70 text-sm leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div>
          <div className="text-xs tracking-[0.25em] uppercase text-white/60 mb-4">{t.footer.explore}</div>
          <ul className="space-y-2 text-white/80 text-sm">
            <li><Link to="/jobs" className="hover:text-white">{t.nav.jobs}</Link></li>
            <li><Link to="/services" className="hover:text-white">{t.nav.services}</Link></li>
            <li><Link to="/about" className="hover:text-white">{t.nav.about}</Link></li>
            <li><Link to="/contact" className="hover:text-white">{t.nav.contact}</Link></li>
            <li><Link to="/hire" className="hover:text-white">{t.nav.hire}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-[0.25em] uppercase text-white/60 mb-4">{t.footer.contact}</div>
          <ul className="space-y-3 text-white/80 text-sm">
            <li className="flex gap-2"><MapPin size={16} className="mt-0.5 text-brandred" /> <span>{t.footer.address}</span></li>
            <li className="flex gap-2"><Mail size={16} className="mt-0.5 text-brandred" /> <a href="mailto:enzo@encesglobal.info" className="hover:text-white">enzo@encesglobal.info</a></li>
            <li className="flex gap-2"><Phone size={16} className="mt-0.5 text-brandred" /> <a href="tel:+12014709244" className="hover:text-white">+1 (201) 470-9244</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-[0.25em] uppercase text-white/60 mb-4">{t.footer.brochure}</div>
          <p className="text-white/70 text-sm mb-4">{t.footer.brochureDesc}</p>
          <a href={`${API_BASE}/brochure`} target="_blank" rel="noreferrer"
             className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-brandred hover:bg-red-700 text-white text-sm font-semibold transition-colors"
             data-testid="footer-brochure-link">
            {t.common.downloadBrochure}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-pad mx-auto max-w-[1400px] py-6 flex flex-col md:flex-row gap-2 justify-between items-center text-xs text-white/60">
          <div>© {new Date().getFullYear()} ENCES Global. {t.footer.rights}</div>
          <div className="tracking-widest uppercase">Union City, NJ · USA</div>
        </div>
      </div>
    </footer>
  );
}
